import React, { useState } from "react";
import { Row, Col, Card, Button, Typography } from "antd";
import showCardInfo from "./showCardInfo";
import { FileSearchOutlined } from "@ant-design/icons";
import DraggableModal from "../../../helper/DraggableModal";
import moment from "moment";
import GroupAccess from "../../../helper/GroupAccess";
const { Paragraph } = Typography;

const TxDetails = (props) => {
    const { t, loading, data } = props;
    const [modal, setModal] = useState({ title: "", content: "" });
    const [isModalVisible, setIsModalVisible] = useState(false);
    
    const getCardDetails = () => {
        let CardDetails = data.CardDetails ? data.CardDetails : [];
        let fields = CardDetails.map(({ name, title, value }) => ({
            label: t(`contents.transactions.form.${title.split(" ").join("_").replace(".", "").toLowerCase()}`),
            name: name,
            value: value,
        }));

        return showCardInfo(fields);
    };

    const showModal = (params) => {
        setModal(params);
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const IsJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };

    const getInitAndDOMDetails = () => {
        let initData = data.requestInfo?.init ? JSON.stringify(data.requestInfo.init) : '';
        let optionData = data.requestInfo?.init ? JSON.stringify(data.requestInfo.option) : '';
        let domData = data.requestInfo?.dom ? JSON.stringify(data.requestInfo.dom) : '';

        let fields = [{
            label: t('contents.transactions.form.init_data'),
            name: 'init_data',
            value:  <Button type="link" size="small" onClick={() => showModal({title: t('contents.transactions.form.init_data'), content: initData}) }>
                        <FileSearchOutlined style={{ fontSize: '18px !important', color: 'rgba(0, 0, 0, 0.85)' }}/>
                    </Button>,
        },
        {
            label: t('contents.transactions.form.option_data'),
            name: 'option_data',
            value:  <Button type="link" size="small" onClick={() => showModal({title: t('contents.transactions.form.option_data'), content: optionData}) }>
                        <FileSearchOutlined style={{ fontSize: '18px !important', color: 'rgba(0, 0, 0, 0.85)' }}/>
                    </Button>,
        },
        {
            label: t('contents.transactions.form.dom_elements'),
            name: 'dom_elements',
            value:  <Button type="link" size="small" onClick={() => showModal({title: t('contents.transactions.form.dom_elements'), content: domData})}>
                        <FileSearchOutlined style={{ fontSize: '18px !important', color: 'rgba(0, 0, 0, 0.85)' }}/>
                    </Button>,
        }];

        return showCardInfo(fields, 16, 8);
    }

    const getChallengeTimeDetails = () => {

        const duration = ( data.dateTimeChallengeInit && data.dateTimeChallengeDone ) ? moment.duration(moment(data.dateTimeChallengeDone, 'YYYY-MM-DD HH:mm:ss').diff(moment(data.dateTimeChallengeInit, 'YYYY-MM-DD HH:mm:ss'))) : null;

        let fields = [{
            label: t('contents.transactions.form.init_challenge_time'),
            name: 'init_data',
            value:  data.dateTimeChallengeInit,
        },
        {
            label: t('contents.transactions.form.done_challenge_time'),
            name: 'option_data',
            value:  data.dateTimeChallengeDone,
        },
        {
            label: t('contents.transactions.form.completion_duration'),
            name: 'dom_elements',
            value:  (duration) ? `${duration.hours()}h ${duration.minutes()}m ${duration.seconds()}s` : '',
        }];

        return showCardInfo(fields, 12, 12);
    }

    const getModalComponent = () => (
        <DraggableModal
            name={modal.title}
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            width={800}
            footer={[
                <Button key="submit" type="primary" onClick={handleOk}>
                    {t("tables.actions.ok")}
                </Button>,
            ]}
            context={
                <Typography>
                    <Paragraph className="well">
                        {IsJsonString(modal.content) ? JSON.stringify(JSON.parse(modal.content), null, "\t") : modal.content}
                    </Paragraph>
                </Typography>
            }
        />
    );

    const getTxDetails = () => (
        <Card loading={loading}>
            {data.tx ? (
                <Row gutter={0}>
                    <Col span={8}>
                        <h4 className="details-info--title">{t('contents.transactions.form.card_details')}</h4>
                        {getCardDetails()}
                    </Col>
                    <Col span={8}>
                        <h4 className="details-info--title"> {t('contents.transactions.form.init_and_dom_details')} </h4>
                        { <> {getInitAndDOMDetails()} {getModalComponent()} </> }

                    </Col>
                    <Col span={8}>
                        {
                            GroupAccess("SYSADMIN") ?
                            <>
                                <h4 className="details-info--title"> { t('contents.transactions.form.challenge_duration_details') } </h4>
                                { getChallengeTimeDetails() }
                            </>
                            : null
                        }
                    </Col>
                </Row>
            ) : (<div className="text-center" style={{ marginTop: 15, marginBottom: 15 }}>{t('contents._3dsecure_stats.no_data')}</div>)}
        </Card>
    );

    return getTxDetails();
};

export default TxDetails;
